import { Icon, MenuItem, Typography, useTheme } from '@web-chat-core/ui-kit';
import { useTranslation } from 'react-i18next';
import { ModalName } from 'features/Modals';
import { useModal } from 'useCase/modal/useModal';
import { useCallback } from 'react';

export const VirtualBackgroundMenuItem = () => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { toggleModal } = useModal();

    const handleClick = useCallback(() => {
        toggleModal(ModalName.VIRTUAL_BACKGROUND);
    }, []);

    return (
        <MenuItem id="virtual-background-menu-item" type="dropdown" onClick={handleClick}>
            <Icon icon="icAddFacePhoto" color={theme.root.colors.basicColors['60%']} size={24} />
            <Typography variant="body3" colorVariant="base">
                {t('videoconference_virtual_backgrounds')}
            </Typography>
        </MenuItem>
    );
};
